import axios from 'axios'
import { FlashMessage } from '@/component/module/flashMessage/flashMessage'

export const FlashMessageHandler = (() => {
	const processResponsePayload = (payload: any) => {
		if (payload instanceof Object) {
			if ('flashes' in payload) {
				for (const flashData of payload.flashes) {
					const { type, message } = flashData
					FlashMessage.show(message, type)
				}
			}
		}
	}
	const initHandler = () => {
		axios.interceptors.response.use((response) => {
			const { data } = response

			processResponsePayload(data)

			return response
		})

		// @ts-ignore
		$.nette.ext({
			success: processResponsePayload,
		})
	}

	const init = () => {
		initHandler()
	}

	return {
		init,
	}
})()
